export default import.meta.ROLLUP_FILE_URL_wGB_qPdB5dRdDVzIs30TVw